import { useContext } from "react";
import { Box } from "@mui/material";
import { ParagraphText } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { NEW_SORT } from "../../../constants";
import { SortArrow } from "../../Features/NewInvoiceBook/InvoiceBookPages/InvoiceList";
import { analytics, triggerLogEvent } from "../../../config/firebase";

export const SaleTableHeads = [
  {
    i18nKey: "date",
    isArrow: true,
    onClick: (filters, handleFilterChange) => {
      const newSort = filters.sort == "Oldest" ? "Newest" : "Oldest";
      triggerLogEvent(analytics, "sale_sort", { column: "date", direction: newSort });
      handleFilterChange("sort", newSort);
    },
    showDataKey: "date",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "sidebarOption",
  },
  {
    i18nKey: "type",
    isArrow: true,
    onClick: (filters, handleFilterChange) => {
      const newSort = filters.sort == NEW_SORT.invoice ? NEW_SORT.pos : NEW_SORT.invoice;
      triggerLogEvent(analytics, "sale_sort", { column: "type", direction: newSort });
      handleFilterChange("sort", newSort);
    },
    showDataKey: "type",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "contact",
    showDataKey: "cust_name",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },

  {
    i18nKey: "status",
    showDataKey: "status",
    className: "textLeft",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "amount",
    showDataKey: "amount",
    rsLabel: true,
    className: "textRight",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "balance",
    showDataKey: "balance",
    rsLabel: true,
    className: "textRight",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
  {
    i18nKey: "actions",
    showActionButton: true,
    className: "textCenter",
    bodyClassName: "newFontColor",
    columnClassName: "",
  },
];

const SaleListTableHeader = ({ filters, handleFilterChange, type, disabled = false }) => {
  const [I18n] = useContext(LanguageContext);

  const columnLabel = (headInfo) => {
    if (type === "in") {
      return I18n[headInfo.i18nKey];
    }
    if (headInfo.i18nKeyOut) {
      return I18n[headInfo.i18nKeyOut];
    }
    return I18n[headInfo.i18nKey];
  };

  return (
    <Box className="invoiceListTableHeader">
      {SaleTableHeads.map((headInfo, ind) => (
        <Box
          key={ind}
          onClick={
            headInfo.onClick && !disabled
              ? () => headInfo.onClick(filters, handleFilterChange)
              : undefined
          }
          className={`invListTableHeaderCol sevenColumn ${headInfo.className} ${headInfo.columnClassName || ""} ${
            headInfo.onClick && !disabled ? "cursorPointer" : ""
          }`.trim()}
        >
          {(!("displayOn" in headInfo) || headInfo.displayOn === type) && (
            <ParagraphText
              className="fontSize12 fontWeight500 newLightColor"
              key={headInfo.i18nKey}
            >
              {columnLabel(headInfo)}
              {headInfo.isArrow ? (
                <SortArrow
                  id={
                    headInfo.showDataKey === "date"
                      ? type === "out"
                        ? "pb_date_sort"
                        : "sale_inv_date_sort"
                      : type === "out"
                        ? "pb_status_sort"
                        : "sale_inv_status_sort"
                  }
                  isAscending={
                    headInfo.showDataKey === "date"
                      ? filters?.sort == "Oldest"
                      :
                      headInfo.showDataKey === "type" ?
                      filters?.sort == NEW_SORT.invoice
                      :
                      null
                  }
                  disabled={disabled}
                />
              ) : null}
            </ParagraphText>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default SaleListTableHeader;
